import { Explicacao } from '../../components/Explicacao'
import { TEXTOS } from '../../lib/glossario'
import type { AreaTocada } from '../../types/repositorios'

const INTEIRO = new Intl.NumberFormat('pt-BR')

const CELULA = 'px-3 py-2 text-right tabular-nums text-slate-700'

/**
 * As áreas do código mais tocadas no período — o "onde se mexeu" que o dono pediu.
 *
 * A barra é proporcional à área mais tocada, e não ao total: o que interessa é a comparação
 * entre áreas, e uma barra sobre o total ficaria toda curta num mês espalhado.
 *
 * @param props as áreas, da mais tocada para a menos
 * @returns a tabela, ou nada quando não há área medida
 */
export function AreasMaisTocadas({ areas }: { areas: AreaTocada[] }) {
  const t = TEXTOS.repositorios.modificado
  if (areas.length === 0) {
    return null
  }
  const maior = Math.max(...areas.map((a) => a.commits), 1)

  return (
    <div className="overflow-x-auto">
      <h3 className="px-3 text-sm font-semibold text-slate-800">{t.areas}</h3>
      <table className="mt-2 min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 text-left text-xs font-semibold text-slate-500">
            <th className="px-3 py-2">
              <span className="inline-flex items-center gap-1">
                {t.colunas.area}
                <Explicacao termo="areaDoCodigo" />
              </span>
            </th>
            <th className="w-1/3 px-3 py-2">
              <span className="sr-only">{t.colunas.commits}</span>
            </th>
            <th className="px-3 py-2 text-right">{t.colunas.commits}</th>
            <th className="px-3 py-2 text-right">{t.colunas.pessoas}</th>
            <th className="px-3 py-2 text-right">{t.colunas.arquivos}</th>
          </tr>
        </thead>
        <tbody>
          {areas.map((area) => (
            <tr key={area.area} className="border-b border-slate-100 last:border-0">
              <td className="px-3 py-2 font-mono text-xs text-slate-900">{area.area}</td>
              <td className="px-3 py-2">
                <span
                  aria-hidden="true"
                  className="block h-2 rounded-full bg-niteroi-500"
                  style={{ width: `${Math.max(4, Math.round((100 * area.commits) / maior))}%` }}
                />
              </td>
              <td className={`${CELULA} font-semibold text-slate-900`}>{INTEIRO.format(area.commits)}</td>
              <td className={CELULA}>{INTEIRO.format(area.pessoas)}</td>
              <td className={CELULA}>{INTEIRO.format(area.arquivos)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
